'use strict';

angular.module('ntmApp').factory('ListGridCell',['ListGridHelper', 'ListGridStatus', 'ListGridConstants', 'CellTemplates', 'ColumnDependencies', 'FormService', 'filterFilter', '$filter',
    function (ListGridHelper, ListGridStatus, ListGridConstants, CellTemplates, ColumnDependencies, FormService, filterFilter, $filter) {

    function ListGridCell() {

        var self = this;

        self.cellData = {};

        self.columnDependencies = new ColumnDependencies();

        self.getCellSettings = function (column, minWidth, enableHiding) {

            var item = {};
            item.name = column.name;
            item.fieldName = column.fieldName;
            item.width = column.columnWidth || null;
            item.minWidth = minWidth;
            item.visible = ListGridStatus.gridSettings.preferences.isColumnVisible(item.name);
            item.enableHiding = enableHiding && !ListGridStatus.gridSettings.dragging.compareSequenceField(column.fieldName);
            item.cellTooltip = true;
            item.headerTooltip = column.cluetip && column.cluetip.content ? column.cluetip.content.replace(/<[^>]+>/gm, '') : false;
            item.headerCellClass = ListGridHelper.highlightFilteredHeader;

            return item;
        };

        self.setDialogCellTemplate = function (column, cell) {

            switch (column.type) {

                case 'CHECKBOX':
                    cell.type = 'boolean';
                    cell.cellTemplate = '<input ng-if="!row.groupHeader" ng-disabled="true" type="checkbox" ng-checked="COL_FIELD!=0" ng-model="MODEL_COL_FIELD">';
                    column.filterType = column.filterType || 'CHECKBOX';

                    break;

                case 'NUMERIC':
                    switch (column.propertyObj.displayAs) {
                        case ListGridConstants.NumberDisplayTypes.Percent: case ListGridConstants.NumberDisplayTypes.ProgressBar:
                            cell.cellTemplate = '<div class="ui-grid-cell-contents"><progress-completed-bar ng-if="!row.groupHeader" decimals="{0}" value="MODEL_COL_FIELD" data="grid.appScope.grid.cell.cellData.{1}"></progress-completed-bar></div>'.format(column.decimals || 0, column.fieldName);
                            self.cellData[column.fieldName] = column.propertyObj;
                            break;

                        case ListGridConstants.NumberDisplayTypes.DurationSplit:
                            cell.cellTemplate = '<div class="ui-grid-cell-contents">{{COL_FIELD | durationSplit: "{0}"}}</div>'.format(column.propertyObj.type || '');
                            break;

                        default:
                            cell.cellTemplate = '<div class="text-right ui-grid-cell-contents" title="{{COL_FIELD | number:{0}}}">{{COL_FIELD | number:{1}}}</div>'.format(column.decimals || 0, column.decimals || 0);

                    }
                    column.filterType = column.filterType || 'NUMBER';
                    break;

                case 'DATE':
                    cell.type = 'date';
                    cell.minWidth = '150';
                    cell.cellTemplate = '<div class="ui-grid-cell-contents" title="{{COL_FIELD | date:\'MM/dd/yyyy\'}}">{{COL_FIELD | date:\'MM/dd/yyyy\'}}</div>';
                    column.filterType = column.filterType || 'DATE';
                    self.hasDate = true;
                    break;

                case ('RADIOBOOLEAN'):
                    column.filterType = column.filterType || 'RADIOBOOLEAN';
                    break;

                case ('COLOR'):
                    cell.cellTemplate = CellTemplates.COLOR.format('ng-if="true"', 'ng-if="false"');
                    self.colorPickerSettings = CellTemplates.ColorPickerSettings;
                    break;

                case ('ICON'):
                    cell.cellTemplate = '<div class="ui-grid-cell-contents" tabindex="-1" {0}><awesome-icon ng-if="MODEL_COL_FIELD" ng-model="MODEL_COL_FIELD"></awesome-icon></div>';
                    break;

                case ('TIME'):
                    column.filterType = column.filterType || 'TIME';
                    cell.cellTemplate = '<div class="ui-grid-cell-contents text-right" tabindex="-1"  title="{{COL_FIELD | fromutc: \'h:mm A\'}}">{{COL_FIELD | fromutc:" h:mm A"}} </div>';
                    cell.sortingAlgorithm = function (a, b) {
                        var time1 = moment(moment(a).format('HH:mm'), 'h:mma');
                        var time2 = moment(moment(b).format('HH:mm'), 'h:mma');

                        if (time1.isAfter(time2)) {
                            return 1;
                        } else {
                            return -1;
                        }
                    };
                    break;

            }
        };

        self.setInlineCellTemplate = function (column, cell) {

            var displayMode = column.protect ? '' : column.editProtect ? 'ng-if="!row.addRecord"' : 'ng-if="!row.addRecord && !row.editRecord"';
            var editMode = column.protect ? 'ng-if="false"' : column.editProtect ? 'ng-if="row.addRecord"' : 'ng-if="row.addRecord || row.editRecord"';
            var disabled = column.propertyObj.disabled || self.columnDependencies.dependentColumnCondition.get(column.attributeId) || false;
            var required = column.required ? 'required' : '';

            switch (column.type) {

                case ('CHECKBOX'):
                    displayMode = column.protect ? 'true' : column.editProtect ? '!row.addRecord' : '!row.addRecord && !row.editRecord';
                    cell.cellTemplate = CellTemplates.CHECKBOX.format(displayMode, required);
                    column.filterType = column.filterType || 'CHECKBOX';
                    break;

                case ('NUMERIC'):
                    switch (column.propertyObj.displayAs) {
                        case ListGridConstants.NumberDisplayTypes.Percent: case ListGridConstants.NumberDisplayTypes.ProgressBar:
                            cell.cellTemplate = CellTemplates.PROGRESSBAR.format(displayMode, column.decimals || 0, column.name, column.fieldName, column.decimals || 0, editMode, required);
                            self.cellData[column.name] = angular.isObject(column.propertyObj) ? column.propertyObj : {};
                            break;

                        case ListGridConstants.NumberDisplayTypes.DurationSplit:
                            cell.cellTemplate = CellTemplates.DURATIONSPLIT.format(displayMode, column.propertyObj.type, column.propertyObj.type, editMode, column.propertyObj.type !== 'HMS');
                            break;

                        default:
                            cell.cellTemplate = CellTemplates.NUMBER.format(displayMode, editMode, required);
                    
                    }
                    column.filterType = column.filterType || 'NUMBER';
                    break;

                case ('COLOR'):
                    cell.cellTemplate = CellTemplates.COLOR.format(displayMode, editMode);
                    self.colorPickerSettings = CellTemplates.ColorPickerSettings;
                    break;

                case ('ICON'):
                    displayMode = column.protect ? 'ng-if="!row.groupHeader"' : column.editProtect ? 'ng-if="!row.groupHeader && !row.addRecord"' : 'ng-if="!row.groupHeader && !row.addRecord && !row.editRecord"';
                    editMode = column.protect ? 'ng-if="ng-if="false""' : column.editProtect ? 'ng-if="row.addRecord"' : 'ng-if="row.addRecord || row.editRecord"';
                    cell.cellTemplate = CellTemplates.ICON.format(displayMode, editMode);
                    break;

                case ('RADIO'):
                    cell.cellTemplate = CellTemplates.RADIO.format(displayMode, editMode, required);

                    self.cellData[column.name] = angular.isArray(column.propertyObj) ? column.propertyObj : [];
                    break;

                case ('RADIOBOOLEAN'):
                    displayMode = column.protect ? 'ng-if="!row.groupHeader"' : column.editProtect ? 'ng-if="!row.groupHeader && !row.addRecord"' : 'ng-if="!row.groupHeader && !row.addRecord && !row.editRecord"';
                    editMode = column.protect ? 'ng-if="false"' : column.editProtect ? 'ng-if="row.addRecord"' : 'ng-if="row.addRecord || row.editRecord"';
                    cell.cellTemplate = CellTemplates.RADIOBOOLEAN.format(displayMode, editMode, required);
                    column.filterType = column.filterType || 'RADIOBOOLEAN';
                    break;

                case ('DROPLIST'):
                    cell.cellTemplate = CellTemplates.DROPLIST.format(displayMode, editMode, disabled, required);
                    self.cellData[column.name] = column.values;
                    break;

                case ('PICKLIST'):
                    cell.cellTemplate = CellTemplates.LISTBOX.format(displayMode, editMode, disabled, required);
                    preparePicklistData(column);
                    break;

                case ('AUTOCOMPLETE'):
                    
                    cell.cellTemplate = CellTemplates.AUTOCOMPLETE.format(displayMode, editMode, disabled, required);
                    prepareAutoCompleteData(column);
                    break;

                case ('DATE'):
                    cell.type = 'date';
                    cell.minWidth = '150';
                    cell.cellTemplate = CellTemplates.DATE.format(displayMode, editMode, required);
                    column.filterType = column.filterType || 'DATE';
                    self.hasDate = true;
                    break;

                case ('TIME'):
                    cell.cellTemplate = CellTemplates.TIME.format(displayMode, editMode, required);
                    cell.sortingAlgorithm = function (a, b) {
                        var time1 = moment(moment(a).format('HH:mm'), 'h:mma');
                        var time2 = moment(moment(b).format('HH:mm'), 'h:mma');

                        if (time1.isAfter(time2)) {
                            return 1;
                        } else {
                            return -1;
                        }
                    };
                    column.filterType = column.filterType || 'TIME';
                    break;
                case ('EMAIL'):
                    cell.cellTemplate = CellTemplates.EMAIL.format(displayMode, editMode, required);
                    break;

                case ('CHECKBOXLIST'):
                    prepareMultiselectData(column);
                    cell.cellTemplate = CellTemplates.CHECKBOXLIST.format(displayMode, editMode);
                    break;

                default:
                    cell.cellTemplate = CellTemplates.TEXT.format(column.letterCase ? column.letterCase.toLowerCase() : '', displayMode, editMode, required, column.letterCase ? column.letterCase.toLowerCase() : '');
                    break;
            }
        };

        self.processDependencies = function (row, column) {
            if (self.columnDependencies.hasDependencies(column.propertyObj.dependent) && row.entity[column.name]) {
                onDataChanged(row, column, row.entity[column.name]);
            }
        };

        self.getPicklistModel = function (field, row) {
            var column = ListGridHelper.getColumnByName(field);
            var keyColumn = ListGridHelper.getColumnByFieldName(column.propertyObj.key);
            
            if (row.entity[keyColumn.name]) {
                return self.cellData[field].filter(function (item) {
                    return item.id === row.entity[keyColumn.name];
                })[0] || null;
            } else {
                return self.cellData[field].filter(function (item) {
                    return item.id === null && item.value === 'Please Select';
                })[0] || null;
            }
        };

        self.picklistChanged = function (row, field, val) {

            var column = ListGridHelper.getColumnByName(field.field);
            
            if (val && val.id === null && val.value === 'Please Select') {
                row.entity[column.name] = null;
                var keyColumn = ListGridHelper.getColumnByFieldName(column.propertyObj.key);
                if (keyColumn) {
                    row.entity[keyColumn.name] = null;
                }
            } else {
                row.entity[column.name] = val.value;
            }

            onDataChanged(row, field, val && val.id === null ? null : val.value);

            if (self.columnDependencies.hasDependencies(column.propertyObj.dependent)) {
                var depColumns = self.columnDependencies.dependentMap.get(column.fieldName);

                depColumns.forEach(function (dependentColumn) {
                    var request = self.columnDependencies.prepareRequestData(dependentColumn, column, row.entity, ListGridStatus.grid.infoTabModel);

                    if (!request) {
                        return;
                    }

                    if (!row.disabled) {
                        row.disabled = {};
                    }

                    var isEmptySelection = !val || val.value === '' || (val.id === null && val.value === 'Please Select');
                    row.disabled[dependentColumn.name] = isEmptySelection;

                    if (self.cellData[dependentColumn.name]) {
                        self.cellData[dependentColumn.name].disabled = isEmptySelection;
                    }

                    FormService.Picklist(request).then(function (result) {

                        switch (dependentColumn.type) {
                            case 'CHECKBOXLIST':
                                self.cellData[dependentColumn.name].options = [];

                                if (result.success) {
                                    result.data.forEach(function (val) {
                                        if (dependentColumn.propertyObj.display && dependentColumn.propertyObj.display.length > 0) {
                                            dependentColumn.propertyObj.display.forEach(function (field) {
                                                if (val[field]) {
                                                    var rec = { id: val[field].trim(), value: val[field].trim() };

                                                    if (dependentColumn.propertyObj.groupBy) {
                                                        rec.groupBy = val[dependentColumn.propertyObj.groupBy];
                                                    }

                                                    self.cellData[dependentColumn.name].options.push(rec);
                                                }
                                            });
                                        }
                                    });
                                }

                                break;

                            case 'PICKLIST':
                                self.cellData[dependentColumn.name] = [];
                                
                                if (dependentColumn.propertyObj.key && dependentColumn.propertyObj.display) {
                                    var pleaseSelectItem = {
                                        id: null,
                                        value: 'Please Select',
                                        sortOrder: 0
                                    };
                                    if (dependentColumn.propertyObj.groupBy) {
                                        pleaseSelectItem.groupBy = '';
                                    }
                                    self.cellData[dependentColumn.name].push(pleaseSelectItem);
                                }
                                
                                if (result.success) {
                                    result.data.forEach(function (val) {

                                        if (dependentColumn.propertyObj.key && dependentColumn.propertyObj.display) {

                                            var item = {
                                                id: val[dependentColumn.propertyObj.key],
                                                value: val[dependentColumn.propertyObj.display[0]],
                                                sortOrder: 1
                                            };

                                            if (dependentColumn.propertyObj.groupBy) {
                                                item.groupBy = val[dependentColumn.propertyObj.groupBy];
                                            }

                                            self.cellData[dependentColumn.name].push(item);
                                        }
                                    });
                                }

                                break;

                            case 'AUTOCOMPLETE':
                                dependentColumn.values = result.data;
                                prepareAutoCompleteData(dependentColumn);

                                break;
                        }

                        dependentColumn.values = result.data;
                    });
                });
            }

            if (self.animation) {
                self.animation.performInlineAnimation(row.entity, self.cellData);
            }
        };

        self.autoCompleteOnSelect = function (row, field, value) {
            var column = ListGridHelper.getColumnByName(field.field);

            if (!column) {
                return;
            }

            var keyColumn = ListGridHelper.getColumnByFieldName(column.propertyObj.key);

            if (!keyColumn) {
                return;
            }

            var selectedValue = ListGridHelper.getValueByKey(column, value);

            row.entity[keyColumn.name] = selectedValue ? selectedValue[column.propertyObj.key] : null;

            onDataChanged(row, field, value);
        };

        //private methods

       function preparePicklistData(column) {

            self.cellData[column.name] = [];

            if (column.propertyObj.type && column.propertyObj.type === 'STATUS_PICKER') {
                self.cellData[column.name].push('Please Select');
            } else {
                if (column.propertyObj.key && column.propertyObj.display) {
                    var pleaseSelectItem = {
                        id: null,
                        value: 'Please Select',
                        sortOrder: 0
                    };
                    if (column.propertyObj.groupBy) {
                        pleaseSelectItem.groupBy = '';
                    }
                    self.cellData[column.name].push(pleaseSelectItem);
                }
            }

            column.values.forEach(function (val) {

                if (column.propertyObj.type && column.propertyObj.type === 'STATUS_PICKER') {

                    if (val[column.propertyObj.display[1]]) {
                        self.cellData[column.name].push(val[column.propertyObj.display[1]].trim());
                    }
                } else {

                    if (column.propertyObj.key && column.propertyObj.display) {

                        var item = {
                            id: val[column.propertyObj.key],
                            value: val[column.propertyObj.display[0]],
                            sortOrder: 1
                        };

                        if (column.propertyObj.groupBy) {
                            item.groupBy = val[column.propertyObj.groupBy];
                        }

                        self.cellData[column.name].push(item);
                    }
                }
            });
        }

        function prepareAutoCompleteData(column) {

            self.cellData[column.name] = {};
            self.cellData[column.name].displayField = column.propertyObj.display[0];

            self.cellData[column.name].getOptions = function (search) {
                var results = filterFilter(column.values, { [column.propertyObj.display[0]]: search });

                if (column.propertyObj.groupBy) {
                    results.map(function (res) {
                        res.group = res[column.propertyObj.groupBy];
                        return res;
                    });

                    results = _us.groupBy(results, column.propertyObj.groupBy);
                    results = _us.map(results, function (g) {
                        g[0].firstInGroup = true;  // the first item in each group
                        return g;
                    });
                    results = _us.flatten(results);
                    results = $filter('orderBy')(results, 'group');
                }

                return results;
            };
        }

        function prepareMultiselectData(column) {
            self.cellData[column.name] = {};

            self.cellData[column.name].options = [];

            if (column.values && column.values.length > 0) {
                column.values.forEach(function (val) {
                    if (column.propertyObj.display && column.propertyObj.display.length > 0) {
                        column.propertyObj.display.forEach(function (field) {
                            if (val[field]) {
                                var rec = { id: val[field].trim(), value: val[field].trim() };

                                if (column.propertyObj.groupBy) {
                                    rec.groupBy = val[column.propertyObj.groupBy];
                                }

                                self.cellData[column.name].options.push(rec);
                            }
                        });
                    }
                });
            }


            self.cellData[column.name].events = {
                onItemSelect: function () {
                    
                },
                onItemDeselect: function () {
                  
                }
            };

            self.cellData[column.name].extra = {
                smartButtonMaxItems: 2,
                scrollableHeight: '200px',
                enableSearch: true,
                allowSelectionByGroups: column.propertyObj.selectByGroup,
                smartButtonTextConverter: function (itemText) {
                    return itemText;
                }
            };

            self.cellData[column.name].settings = { buttonDefaultText: 'Please Select' };
            self.cellData[column.name].disabled = column.propertyObj.disabled || self.columnDependencies.dependentColumnCondition.get(column.attributeId);
            self.cellData[column.name].groupBy = column.propertyObj.groupBy ? 'groupBy' : false;

        }

        function onDataChanged(row, field, value) {
            var column = ListGridHelper.getColumnByName(field.field);

            if (!column) {
                return;
            }

            var columnValue = ListGridHelper.getValueByKey(column, value);

            if (!columnValue) {
                return;
            }

            column.propertyObj.fields.forEach(function (field) {

                if (column.propertyObj.display && field === column.propertyObj.display[0] || field === column.propertyObj.key) {
                    return;
                }

                var col = ListGridHelper.getColumnByFieldName(field);

                if (col) {
                    switch (col.type) {
                        case ('DATE'):
                            row.entity[col.name] = columnValue[field] ? new Date(columnValue[field]) : null;
                            break;
                        case ('TIME'):
                            row.entity[col.name] = columnValue[field] ? new Date(moment(columnValue[field], 'hh:mm A')) : null;
                            break;
                        case ('CHECKBOXLIST'):
                            row.entity[col.name] = columnValue[field] && columnValue[field].substr(columnValue[field].length - 1) === ';' ? columnValue[field].slice(0, -1) : columnValue[field];
                            break;

                        default:
                            row.entity[col.name] = columnValue[field];
                    }
                }
            });
        }
    }

    return (ListGridCell);
}]);
